module.exports = __webpack_public_path__ + "static/media/icon_close_gray.9530f776.svg";